import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import ListAction from 'core/actions/ListAction'

const { cinder } = ApiClient.getInstance()

export const cinderMessageActions = ActionsSet.make<DataKeys.CinderMessages>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.CinderMessages,
  cacheKey: DataKeys.CinderMessages,
  addCacheKey: DataKeys.CinderMessages,
})

export const listCinderMessages = cinderMessageActions.add(
  new ListAction<DataKeys.CinderMessages>(async () => {
    return cinder.getCinderMessages()
  }),
)
